function login() {
	/*
	 * Validation
	 */

	var input = {
		strong: $("#input-password-strong"),
		emailPattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		noNumbersPattern: /([0-9])/,
		capitalLetterPattern: /([A-Z])/,
		noSpecialPattern: /([!@#$%^&*\-\=~`\[\{\]\}\|\\\:\;\"\'\,\.\/\<\>\?])/
	};

	var minPasswordLength = 8,
		maxPasswordLength = 30,
		maxPasswordStrengthPointsOfLength = 3;

	var validation = {
		methods: {
			isNotEmpty: function (value) {
				return value.length > 0;
			},
			isMinLength: function (value, min) {
				return value.length >= min;
			},
			isMaxLength: function (value, max) {
				return value.length <= max;
			},
			areSame: function (value1, value2) {
				return value1 == value2;
			},
			isMail: function (value) {
				return input.emailPattern.test(value);
			},
			isPhone: function (value) {
				return value.length == 11 || value.length == 12;
			},
			hasNoNumbers: function (value) {
				return !input.noNumbersPattern.test(value);
			},
			hasNoSpecialChars: function (value) {
				return !input.noSpecialPattern.test(value);
			},
			hasCapitalLetter: function (value) {
				return input.capitalLetterPattern.test(value);
			},
			fileLoaded: function (value) {
				return !!value;
			},
			maxFileSize: function (value) {
				return value[0].files[0].size <= 5242880;
			},
			minFileSize: function (value) {
				return value[0].files[0].size > 1024;
			},
			properPdfFormat: function (value) {
				return "pdf" == value.split(".").pop().toLowerCase();
			}
		},
		rules: {
			name: function (value) {
				return (
					validation.methods.isNotEmpty(value) &&
					validation.methods.isMinLength(value, 2) &&
					validation.methods.isMaxLength(value, 64) &&
					validation.methods.hasNoNumbers(value) &&
					validation.methods.hasNoSpecialChars(value)
				);
			},
			companyName: function (value) {
				return (
					validation.methods.isNotEmpty(value) &&
					validation.methods.isMaxLength(value, 64)
				);
			},
			industry: function (value) {
				return (
					validation.methods.isNotEmpty(value) &&
					validation.methods.isMaxLength(value, 64)
				);
			},
			description: function (value) {
				return (
					validation.methods.isNotEmpty(value) &&
					validation.methods.isMaxLength(value, 1024)
				);
			},
			mail: function (value) {
				return (
					validation.methods.isNotEmpty(value) &&
					validation.methods.isMaxLength(value, 64) &&
					validation.methods.isMail(value)
				);
			},
			phone: function (value) {
				return (
					validation.methods.isNotEmpty(value) &&
					validation.methods.isPhone(value)
				);
			},
			password: function (value) {
				return (
					validation.methods.isMinLength(value, minPasswordLength) &&
					validation.methods.isMaxLength(value, maxPasswordLength) &&
					validation.methods.hasCapitalLetter(value)
				);
			},
			password2: function (value) {
				return validation.methods.areSame(
					value,
					$('[data-validate-type="password"]').val()
				);
			},
			fileAgreement: function (value) {
				return (
					validation.methods.fileLoaded(value) &&
					validation.methods.maxFileSize(
						$("#fileInput,#fileInputRegistration")
					) &&
					validation.methods.minFileSize($("#fileInput,#fileInputRegistration"))
				);
			}
		}
	};

	function validate(form) {
		if (!form) return;

		var formInputs = $(form).find(".input");
		var formPasswords = $(form).find(".input-password");
		var allInputs = $(form).find(".input-password,#fileInput,.input");
		var formSubmit = $(form).find(
			'[type="submit"],#register-button,#login-button,#reset-button'
		);
		var uploadFile = $(form).find(".input-file");
		var uploadFileLabel = $(form).find(".input-file__label");
		var fileNotFound = $("#file-not-found");
		var itemsErrorMessagesContainer = $(form).find(".validate-messages");

		var allEditableInputs = $(form).find(".input-password,#fileInput,.input");

		function getAllValidatedInputs() {
			return $(form).find(
				".input-password.correct,#fileInput.correct,.input.correct"
			);
		}

		function isFormValid() {
			var allFielsValid = true;
			$.each(allInputs, function (index, element) {
				if (!validateSingleInput($(element))) {
					allFielsValid = false;
				}
			});
			showErrorMessages();

			return allFielsValid;
		}
		function showErrorMessages() {
			var formContainsErrors =
				$(form).find("[data-validate-type]:not([type='file']).error").length >
				0;
			if (formContainsErrors) {
				$(form).find(".validate-login-invalid").hide();
				itemsErrorMessagesContainer.addClass("show");
			} else {
				itemsErrorMessagesContainer.removeClass("show");
			}
		}

		function validateSingleInput(el) {
			if (el.attr("data-validate-type")) {
				var isItemValid = validation.rules[el.attr("data-validate-type")](
					el.val()
				);
				var itemErrorMessage = $(form).find(
					".validate-messages__" + el.attr("data-validate-type")
				);

				if (el.val() != "") {
					el.addClass("touched");
					if (!isItemValid) {
						el.addClass("error");
						el.removeClass("correct");
						itemErrorMessage.addClass("show");
					} else {
						el.removeClass("error");
						el.addClass("correct");
						itemErrorMessage.removeClass("show");
					}
				} else {
					el.removeClass("correct");
					el.removeClass("error");
					el.removeClass("touched");
					itemErrorMessage.removeClass("show");
				}
				if (
					form.attr("id") === "registration-form" ||
					form.attr("id") === "login-form" ||
					form.attr("id") === "reset-password"
				) {
					if (allEditableInputs.length === getAllValidatedInputs().length) {
						formSubmit.attr("disabled", false);
						formSubmit.removeClass("button--inactive");
					} else {
						formSubmit.attr("disabled", true);
						formSubmit.addClass("button--inactive");
					}
				}
				return isItemValid;
			} else {
				return true;
			}
		}

		function addInputListeners() {
			formInputs.on("input change", function (e) {
				validateSingleInput($(e.target));
				showErrorMessages();
			});
		}

		function addPasswordListeners() {
			formPasswords.on("input change", function (e) {
				formPasswords.each(function (index, el) {
					validateSingleInput($(el));
					showErrorMessages();
				});
			});
		}

		function addUploadFileListener() {
			uploadFile.on("click", function (e) {
				uploadFileLabel.hasClass("not-empty") ? e.preventDefault() : false;
			});

			uploadFile.on("change", function (e) {
				if (validateSingleInput($("#fileInput,#fileInputRegistration"))) {
					$("#fileUploaded").addClass("upload-file-success");
					$("#fileUploaded").removeClass("upload-file-error").hide();
					$("#fileInput,#fileInputRegistration").addClass("correct");
				} else {
					$("#fileUploaded").addClass("upload-file-error");
					$("#fileUploaded").removeClass("upload-file-success").show();
					$("#fileInput,#fileInputRegistration").removeClass("correct");
				}
				var file = $("#fileInput,#fileInputRegistration").val();
				var fileName = file.split("\\");
				var name = fileName[fileName.length - 1];
				var deleteFileBtn = $("<button id='file-delete-btn'>delete</button>");
				if (name) {
					// if (name.length > 30) {
					// 	name = name.substring(0, 20) + "..." + name.substr(name.length - 7);
					// }
					fileNotFound.addClass("not-empty");
					uploadFileLabel.addClass("not-empty");
					fileNotFound.text("");
					fileNotFound.append(name).append(deleteFileBtn);
				} else {
					fileNotFound.text("Not attached file");
				}
				showErrorMessages();
			});
		}

		function clearUploadFileListener() {
			$("#file-not-found").on("click", function (e) {
				if (e.target.id == "file-delete-btn") {
					$("#fileInput,#fileInputRegistration")
						.val("")
						.removeClass("error correct");
					$("#fileUploaded").hide();
					fileNotFound.removeClass("not-empty");
					uploadFileLabel.removeClass("not-empty");
					fileNotFound.text("");
				}
			});
		}

		function addPreventSubmitListener() {
			formSubmit.on("click", function (e) {
				e.preventDefault();
				if (isFormValid()) {
					if ($("#register-button").length && !isStageEnv) {
						$("#register-button").addClass("loading");
						register(e);
					} else {
						form.submit();
					}
				} else {
					$.each(allInputs, function (index, element) {
						var el = $(element);
						if (el.val() == "") {
							el.addClass("error");
						}
					});
				}
			});
		}
		addInputListeners();
		addPasswordListeners();
		addUploadFileListener();
		clearUploadFileListener();
		addPreventSubmitListener();
		// if form is loaded with values validate it immediately
		isFormValid();
		$("#user-type").val(
			~document.cookie.indexOf("isOmantelReffered=true") ? "OMANTEL" : ""
		);
	}

	validate($("#login-form"));
	validate($("#send-question-form"));
	validate($("#registration-form"));
	validate($("#reset-password"));
	validate($("#reset-password-second"));
	validate($("#registration-confirm-form"));
	validate($("#tasil-plus-form"));
	validate($("#opt-out-form"));

	$("#registration-form").on("submit", function (e) {
		e.preventDefault();
		var formData = $("#registration-form").serialize();
		$.post({
			url: apiPath + "register",
			data: formData,
			crossDomain: true,
			xhrFields: {
				withCredentials: true
			},
			success: function () {
				window.location.replace(apiPath + "app?awesomeUserAward=true");
			},
			error: function (data) {
				if (
					data.responseText &&
					data.responseText.toLowerCase().indexOf("email already in use") > -1
				) {
					window.location.replace(getCurrentUrlWithErrorParam("loginerror"));
				} else {
					window.location.replace(
						getCurrentUrlWithErrorParam("connectionerror")
					);
				}
			}
		});
	});

	$("#login-form").on("submit", function (e) {
		e.preventDefault();
		sessionStorage.setItem("loginemail", $("#username").val());
		var formData = $("#login-form").serialize();
		$.post({
			url: apiPath + "login",
			data: formData,
			crossDomain: true,
			xhrFields: {
				withCredentials: true
			},
			success: function (data, status, jqXHR) {
				//weak check for error (error response is longer)
				if (jqXHR && jqXHR.responseText && jqXHR.responseText.length > 15000) {
					window.location.replace(getCurrentUrlWithErrorParam("loginerror"));
				} else {
					window.location.replace(apiPath + "app");
				}
			},
			error: function (e) {
				window.location.replace(getCurrentUrlWithErrorParam("loginerror"));
			}
		});
	});

	function getCurrentUrlWithErrorParam(error) {
		var url = window.location.href;
		if (url.indexOf(error) < 0) {
			if (url.indexOf("?") > -1) {
				url += "&" + error;
			} else {
				url += "?" + error;
			}
		}
		return url;
	}

	/*
	 * Forgot password
	 */
	var forgotPassword = {
		window: $("#reset-password-window"),
		background: $("#reset-password-bg"),
		firstStep: $("#reset-password-modal"),
		secondStep: $("#reset-password-second-modal"),
		success: $("#reset-password-success"),
		error: $("#reset-password-error"),
		errorOldPassword: $("#reset-password-error-with-old"),
		closeButton: $(".forgot-password__close"),
		openButton: $("#reset-password-link"),
		reset: $("#reset-password"),
		body: $("body"),
		mailSent: false,
		openListener: function () {
			forgotPassword.openButton.on("click", function (event) {
				event.preventDefault();
				forgotPassword.window.show();
				forgotPassword.background.show();
				forgotPassword.firstStep.attr("style", "display: block !important");
				forgotPassword.body.addClass("body-forgot-password");
				forgotPassword.reset.show();
			});
		},
		closeListener: function () {
			$(".contact-support-link").on("click", function () {
				forgotPassword.body.removeClass("body-forgot-password");
				close();
			});
			forgotPassword.closeButton.on("click", function () {
				forgotPassword.body.removeClass("body-forgot-password");
				close();
			});

			function close() {
				forgotPassword.window.hide();
				forgotPassword.background.hide();
				forgotPassword.firstStep.hide();
				forgotPassword.secondStep.hide();
				forgotPassword.success.hide();
				forgotPassword.error.hide();
				forgotPassword.errorOldPassword.hide();
			}
		},
		init: function () {
			this.closeListener();
			this.openListener();
			forgotPassword.reset.on("submit", function (e) {
				e.preventDefault();
				var formData = $("#reset-password").serialize();
				console.log(formData);
				$.post({
					url: apiPath + "resetPassword",
					data: formData,
					success: function (data) {
						if (data.message == "success") {
							forgotPassword.firstStep.attr(
								"style",
								"display: none !important"
							);
							forgotPassword.success.attr("style", "display: block !important");
							forgotPassword.mailSent = true;
						} else {
							forgotPassword.firstStep.attr(
								"style",
								"display: none !important"
							);
							forgotPassword.error.attr("style", "display: block !important");
						}
					},
					error: function (data) {
						forgotPassword.firstStep.attr("style", "display: none !important");
						forgotPassword.error.attr("style", "display: block !important");
					}
				});
				forgotPassword.reset.hide();
			});
		}
	};

	forgotPassword.init();

	/*
	 * Slider
	 */
	$(".login-slider").slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		adaptiveHeight: false,
		autoplay: true,
		autoplaySpeed: 7000,
		fade: true,
		cssEase: "ease-in",
		prevArrow: $(".login-slider__arrow--prev"),
		nextArrow: $(".login-slider__arrow--next"),
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					adaptiveHeight: true
				}
			}
		]
	});

	/*
	 * Password strength indicator
	 */
	$(input.strong).on("click", function () {
		$(this).addClass("user-click");
	});

	$("#password").on("input", function (e) {
		input.strong.removeClass(
			"level-0 level-1 level-2 level-3 level-4 user-click"
		);
		var userPassword = $(e.target).val();

		var passwordLengthPoints = Math.floor(
			(userPassword.length / minPasswordLength) *
				maxPasswordStrengthPointsOfLength
		);
		passwordLengthPoints =
			passwordLengthPoints <= maxPasswordStrengthPointsOfLength
				? passwordLengthPoints
				: maxPasswordStrengthPointsOfLength;
		var hasCapitalPoints = /[A-Z]/.test(userPassword) ? 1 : 0;
		var isNotEmpty = !!userPassword.length;

		var passwordLevelTotalPoints = passwordLengthPoints + hasCapitalPoints;
		input.strong.addClass("level-" + passwordLevelTotalPoints);
		isNotEmpty
			? input.strong.addClass("not-empty")
			: input.strong.removeClass("not-empty");
	});

	/*
	 * Show password
	 */
	$("#password-eye").on("click", function (e) {
		var target = $(e.target);
		target.toggleClass("close");
		target.siblings(".input-password").attr("type") == "text"
			? target.siblings(".input-password").attr("type", "password")
			: target.siblings(".input-password").attr("type", "text");
	});
	$("#password-eye2").on("click", function (e) {
		var target = $(e.target);
		target.toggleClass("close");
		target.siblings(".input-password").attr("type") == "text"
			? target.siblings(".input-password").attr("type", "password")
			: target.siblings(".input-password").attr("type", "text");
	});

	/*
	 * Contact number input
	 */
	var allowedChars = /^[\d\b]+$/;
	var removeCharsRegExp = new RegExp("([[a-zA-Z- !@#$%^*()_])+", "g");
	var prefix = "+968";
	var numberField = $("#contactNumber");
	numberField.on("input", function (e) {
		var number = e.target.value.replace(removeCharsRegExp, "");
		if (!(number.length == 0 || number == prefix)) {
			var prefixPos = number.indexOf(prefix);
			if (!~prefixPos) {
				if (allowedChars.test(number)) numberField.val(prefix + number);
				else numberField.val(prefix);
			} else {
				var firstPart = number.slice(0, prefixPos);
				var lastPart = number.slice(prefixPos + prefix.length);
				if (allowedChars.test(firstPart + lastPart))
					numberField.val(prefix + firstPart + lastPart);
				else numberField.val(prefix);
			}
		} else {
			numberField.val(prefix);
		}
	});

	var Cookies = {
		setCookie: function (name, value, days) {
			var expires = "";
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
				expires = "; expires=" + date.toUTCString();
			}
			document.cookie = name + "=" + (value || "") + expires + "; path=/";
		},
		setCookieWithExpirationDate: function (name, value, expirationDate) {
			var expires = "";
			if (expirationDate) {
				var date = new Date(parseInt(expirationDate) * 1000);
				expires = "; expires=" + date.toUTCString();
			}
			document.cookie = name + "=" + (value || "") + expires + "; path=/";
		},
		getCookie: function (name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(";");
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == " ") c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		},
		eraseCookie: function (name) {
			document.cookie = name + "=; Max-Age=-99999999;";
		}
	};

	$(document).ready(function () {
		if (Cookies.getCookie("JSESSIONID")) {
			window.location.replace(apiPath + app);
		}
		if (
			$("#registration-form").length == 1 &&
			Cookies.getCookie("ODM_ANALYTICS_TOKEN") &&
			$("#analyticsToken")[0].value.length == 0
		) {
			$("#analyticsToken")[0].value = Cookies.getCookie("ODM_ANALYTICS_TOKEN");
		}

		if (
			$("#registration-form").length == 1 &&
			!Cookies.getCookie("CAPTURED") &&
			$("#analyticsToken")[0].value.length > 0
		) {
			var analyticsToken = $("#analyticsToken")[0].value;
			var eventData = JSON.stringify({
				url: "/userRegistration",
				token: analyticsToken,
				action: "CAPTURED"
			});
			$.ajax({
				type: "POST",
				url: "/api/events",
				data: eventData,
				contentType: "application/json",
				success: function (tokenInfo) {
					Cookies.setCookieWithExpirationDate(
						"CAPTURED",
						"true",
						tokenInfo.expirationDate
					);
					Cookies.setCookieWithExpirationDate(
						"ODM_ANALYTICS_TOKEN",
						analyticsToken,
						tokenInfo.expirationDate
					);
				},
				error: function (error) {}
			});
		}
		showLoginValidationMessages();
		setAnalyticsTokenFromUrl();
	});

	function showLoginValidationMessages() {
		if (window.location.href.indexOf("loginerror") > -1) {
			$("#username").val(sessionStorage.getItem("loginemail"));
			$("#password").focus();
			if($("#login-form")){
				validate($("#login-form"));
			}
			$("#username").addClass("touched");
			$(".validate-login-invalid").removeClass("hidden");
			$("#register__validate-message").removeClass("hidden");
		}
		if (window.location.href.indexOf("connectionerror") > -1) {
			$(".validate-connection-problem").removeClass("hidden");
			$("#register__connection-message").removeClass("hidden");
		}
		if (window.location.href.indexOf("logout") > -1) {
			$(".validate-logout").removeClass("hidden");
		}
		if (window.location.href.indexOf("sessionEnd=true") > -1) {
			$("#sessionExpired").removeClass("hidden");
		}
	}

	function setAnalyticsTokenFromUrl() {
		if ($("#registration-form").length == 0) {
			return;
		}
		var pathParts = window.location.pathname.split("?")[0].split("/");
		var tokenIndex = pathParts.indexOf("userregistration") + 1;
		if (pathParts[tokenIndex]) {
			$("#analyticsToken").val(pathParts[tokenIndex]);
		}
	}
}
